module.exports = __webpack_public_path__ + "img/wuyou_anquan.2ea69fb5.png";